import React from 'react';
import { Navigate } from "react-big-calendar";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, DatePicker } from "antd";
import dayjs from "dayjs";
import Locale from "../../../../core/locale/locale";


const Toolbar = ({ date,onNavigate,onDateChange}: any) => {

    function handlePrevious() {
        const prev = dayjs(date).subtract(1, "month");

        onNavigate(Navigate.PREVIOUS);

        onDateChange(
            prev.startOf("month").startOf('week').format(Locale.dateFormat),
            prev.endOf("month").endOf('week').format(Locale.dateFormat)
        );
    }

    function handleNext() {
        const next = dayjs(date).add(1, "month");

        onNavigate(Navigate.NEXT);

        onDateChange(
            next.startOf("month").startOf('week').format(Locale.dateFormat),
            next.endOf("month").endOf('week').format(Locale.dateFormat)
        );
    }

    function handleMonthYearChange(value: any) {
        if (!value) return;

        onNavigate(Navigate.DATE, value.toDate());

        const startDate = value.startOf("month").startOf('week').format(Locale.dateFormat);
        const endDate = value.endOf("month").endOf('week').format(Locale.dateFormat);

        onDateChange(startDate, endDate);
    }

    return (
        <div className="employee-attendance__calendar-toolbar">

            <div className="employee-attendance__calendar-legend-list">
                <span className="employee-attendance__calendar-legend-item present">Present</span>
                <span className="employee-attendance__calendar-legend-item absent">Absent</span>
                <span className="employee-attendance__calendar-legend-item weekend">Weekend</span>
                <span className="employee-attendance__calendar-legend-item onLeave">On Leave</span>
                <span className="employee-attendance__calendar-legend-item holiday">Holiday</span>
            </div>

            <div className={'employee-attendance__calendar-action-bar'}>
                <Button
                    className="employee-attendance__calendar-nav-icon prev"
                    onClick={handlePrevious}
                >
                    <LeftOutlined/>

                </Button>

                <DatePicker
                    picker="month"
                    value={dayjs(date)}
                    format={(date)=>dayjs(date).format('MMMM')}
                    onChange={handleMonthYearChange}
                    className="employee-attendance__calendar-picker"
                />

                <Button
                    type={'primary'}
                    className="employee-attendance__calendar-today-btn"
                    onClick={() => onNavigate(Navigate.TODAY)}
                >
                    Today
                </Button>

                <Button
                    className="employee-attendance__calendar-nav-icon next"
                    onClick={handleNext}
                >
                    <RightOutlined/>
                </Button>
            </div>
        </div>
    )
}

export default Toolbar;
